import { categories, categoryImages } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-foreground-950 font-heading text-3xl md:text-5xl font-bold mb-4">
            Shop by Category
          </h2>
          <p className="text-foreground-600 text-base max-w-lg mx-auto font-body">
            Browse all 14 product categories available through the ACBuySpreadsheet system. Every category links directly to the full catalog.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative overflow-hidden rounded-2xl aspect-[3/4] cursor-pointer block"
            >
              <img
                src={categoryImages[cat.slug] || categoryImages.shoes}
                alt={`${cat.name} category — ACBuySpreadsheet shopping`}
                title={`${cat.name} — ACBuySpreadsheet category`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-white font-heading text-xl md:text-2xl font-semibold mb-1">
                  {cat.name}
                </h3>
                <p className="text-white/70 text-sm font-label opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Browse catalog →
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}